import { render, staticRenderFns } from "./ConcernMainFile.vue?vue&type=template&id=6b4cb082"
import script from "./ConcernMainFile.vue?vue&type=script&lang=js"
export * from "./ConcernMainFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports